import script from "./DreLayoutCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./DreLayoutCadastro.vue?vue&type=script&setup=true&lang=js"

import "./DreLayoutCadastro.vue?vue&type=style&index=0&id=fbd9cb9c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbd9cb9c"]])

export default __exports__